<template>
  <div
    class="message-voice"
    :class="{
      'is-self': isSelf
    }"
  >
    <VoicePlayer :message="message" width="124px">
      <template #top="{ message: currentMessage }">
        <span class="message-voice__duration">
          <i class="icon-audio-line t-iconfont"></i>
          {{ `${currentMessage.time}''` }}
        </span>
      </template>
    </VoicePlayer>
  </div>
</template>

<script setup>
import VoicePlayer from '../../voice-player/index.vue'

defineProps({
  message: {
    type: Object,
    default: () => ({
      id: '',
      url: '',
      time: ''
    })
  },
  isSelf: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.message-voice {
  display: inline-flex;
  background: #f2f3f5;

  &.is-self {
    // justify-content: flex-end;
    background: #e8f7ff;

    .message-voice__duration {
      flex-direction: row-reverse;
      // justify-content: flex-end;

      .t-iconfont {
        margin-right: 0;
        margin-left: 4px;
        transform: scaleX(-1);
      }
    }
  }

  &__duration {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    color: #323233;

    .t-iconfont {
      margin-right: 4px;
      font-size: 16px;
      line-height: 1;
    }
  }
}
</style>
